module.exports = __webpack_public_path__ + "img/cases-brand-5-cover.b73b1517.png";